import { FC } from 'react';
import Theme from 'App.theme';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';

type TPassFailButton = FC<{
  show: boolean;
  check?: boolean | null;
  answer?: 'pass' | 'fail';
  click?: VoidFunction;
  text: string;
  disabled?: boolean;
}>;

type TPassFailButtons = FC<{
  check?: boolean | null;
  click: (state: boolean) => void;
  disabled?: boolean;
  altFailText?: string;
  altPassText?: string;
}>;

const PassFailButton: TPassFailButton = ({ show, check, answer = 'pass', click, text, disabled = false }) => {
  if (!show) return null;

  const activeColor = disabled ? Theme.greys.GREY3 : answer == 'pass' ? Theme.colours.success : Theme.colours.red;

  const sx = {
    margin: '5px',
    backgroundColor: check ? activeColor : Theme.colours.white,
    color: check ? Theme.colours.white : Theme.colours.black,
  };
  sx['&:hover'] = { ...sx };
  if (disabled) {
    sx['cursor'] = 'default';
    sx['opacity'] = 0.6;
  }

  return (
    <Button sx={sx} onClick={click}>
      {text}
    </Button>
  );
};

const PassFailButtons: TPassFailButtons = ({ check, click, disabled, altFailText, altPassText }) => {
  const lang = useLanguage()[0].CheckInTrayPage;

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <PassFailButton
        show={true}
        check={check}
        click={disabled ? undefined : () => click(true)}
        text={!altPassText ? lang.pass : altPassText}
        disabled={disabled}
      />
      <PassFailButton
        show={true}
        // if the check is not false (eg. if it is null), it will not be seen as checked
        check={Boolean(check == false)}
        answer="fail"
        click={disabled ? undefined : () => click(false)}
        text={(disabled && altFailText != lang.no) || !altFailText ? lang.fail : altFailText}
        disabled={disabled}
      />
    </div>
  );
};

export default PassFailButtons;
